import { render } from "./DialogError.vue?vue&type=template&id=81c7f0e0"
import script from "./DialogError.vue?vue&type=script&lang=js"
export * from "./DialogError.vue?vue&type=script&lang=js"

import "./DialogError.vue?vue&type=style&index=0&id=81c7f0e0&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__